import { createUseStyles } from "react-jss";

export default createUseStyles({
    navigation: {
        bottom: 0,
        composes: "navigation",
        left: 0,
        margin: ({ theme }) =>
            theme.BottomNavigationPosition === "floating" ? [[0, 0]] : [[29, -6]],
        position: ({ theme }) => theme.BottomNavigationPosition === "floating" && "fixed",
        right: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    navigationLeft: {
        marginRight: "5%",
        flex: "1 1 33%",
        display: "flex",
        justifyContent: "flex-start",
        flexWrap: "nowrap",
        "& > .button": {
            flexBasis: "33%",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
        },
    },
    navigationCenter: {
        flex: "1 1 33%",
        display: "flex",
        justifyContent: "center",
        flexWrap: "nowrap",
        "& > .button": {
            flexBasis: "33%",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
        },
    },
    navigationRight: {
        marginLeft: "5%",
        flex: "1 1 33%",
        display: "flex",
        flexWrap: "nowrap",
        justifyContent: "flex-end",
        "& > .button": {
            flexBasis: "33%",
            margin: [["0%", "8px"]],
            padding: [[0, 12]],
        },
    },
    navigationButtonContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        textAlign: "center",
        "& .button": {
            margin: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
            borderRadius: ({ theme }) => theme.BottomNavigationPosition === "floating" && 0,
        },
    },
});
